import React from 'react';
import s from './s.module.less';
import AvatarGroup from 'components/AvatarGroup';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { Button, Modal } from 'antd';
import YouTubePlayer from 'components/YoutubePlayer';
import usePPAChanneld from 'hooks/usePPAChanneld';
import { getHasAutoPopJoinPPAModal, setHasAutoPopJoinPPAModal } from 'utils/localstore';
import ExploreTopProviders from 'components/ExploreTopProviders';

type Props = {
    onClickJoin?: () => void;
    canShowAutoPop: boolean;
};

// hard code two provider
// ppa link: https://www.youtube.com/watch?v=jy8oVJ2aCF4
// https://www.helloklarity.com/provider/derek-timbs?state=texas&condition=weight-loss
// https://www.helloklarity.com/provider/kelly-cobb?state=florida&condition=adhd

const JoinPPABanner = (props: Props) => {
    const { onClickJoin, canShowAutoPop } = props;
    const navigate = useNavigate();
    const [openModal, setOpenModal] = React.useState(false);
    const [ppaId, loading] = usePPAChanneld();
    const timeoutRef = React.useRef<any>(null);

    const openPPAChannel = () => {
        navigate(
            `${PATH.DASHBOARD}/${PATH.CHANNEL_DETAIL}?channelId=${ppaId}`,
        )
    }

    React.useEffect(() => {
        if (canShowAutoPop) {
            timeoutRef.current = window.setTimeout(() => {
                const hasAutoPop = getHasAutoPopJoinPPAModal();
                if (hasAutoPop) {
                    return;
                }
                setOpenModal(true);
                setHasAutoPopJoinPPAModal(true);
            }, 10 * 1000);
        }
        return () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
        };
    }, [canShowAutoPop]);



    return (
        <div>
            <div className={s.wrap}>
                <div className={s.left}>
                    <div className={s.label}>Less than 2 minutes to complete</div>
                    <div className={s.title}>🚀 Join Klarity Health - only pay when patients book</div>
                    <div className={s.des}>Join Klarity Health to get listed, and booked on HelloKlarity.com. Pay only when patients schedule. No monthly fees, no risk.</div>
                </div>
                <div className={s.right}>
                    <AvatarGroup />
                    <p>Trusted by thousands of providers</p>
                    <span className={s.btn}
                        onClick={() => {
                            onClickJoin?.();
                            openPPAChannel();
                        }}
                    >Join now</span>
                </div>
            </div>
            <Modal
                footer={null}
                title="🚀 Join Klarity Health - only pay when patients book"
                open={openModal}
                wrapClassName={s.modalOut}
                onCancel={() => {
                    setOpenModal(false);
                }}
                destroyOnClose
                centered
                width={600}
            >
                <div className={s.modalWrap}>
                    <div className={s.des}>Join Klarity Health to get listed, and booked on HelloKlarity.com. Pay only when patients schedule. No monthly fees, no risk.</div>
                    {/* remove for product in 0530 */}
                    {/* https://app.asana.com/1/1201608580743313/project/1203117087311346/task/1210413601913096?focus=true */}
                    {/* <YouTubePlayer
                        playerWrapClassName={s.playerWrapper}
                        videoId="jy8oVJ2aCF4"
                        show
                    /> */}
                    <div className={s.exploreTitle}>Explore how top providers show up on Klarity</div>
                    <div className={s.explore}>
                        <ExploreTopProviders showNumber={2} />
                    </div>
                    <div className={s.btnWrap}>
                        <Button
                            onClick={() => {
                                onClickJoin?.();
                                openPPAChannel()
                            }}
                            size='large' className={s.btn} type='primary' block>Join now</Button>
                        <div className={s.tips}>
                            Less than <b>2 minutes</b> to complete your onboarding
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default JoinPPABanner;
